import { render } from "./HeroiconsOutlineViewBoards.vue?vue&type=template&id=07f5f290"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineViewBoards.vue"]])

export default __exports__